<template>
  <div class="announcement-ul">
    <div class="announcement-li" v-for="(item, index) in announcement" :key="index" @click="gotoDetails(item.id)">
      <div class="announcement-time">
        <div class="day">{{ item.createTime.slice(6, 8) }}</div>
        <div class="month">{{ showTime(item.createTime, 'month', '.') }}</div>
      </div>
      <div class="announcement-text">
        <div class="announcement-h">
          {{ item.title }}
        </div>
        <div class="announcement-p">
          {{ item.introduction }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTime } from "@/util/public";

export default {
  name: "announcement",
  props: {
    announcement: {
      type: Array,
      required: true
    }
  },
  methods: {
    gotoDetails(id) {
      // this.$router.push({ path: `/QualityControlDetails` }); // 动态路由传递课程 id
      this.$router.push({ path: `/QualityControlDetails/${id}` }); // 动态路由传递课程 id
    },
    showTime(value, type, separation) {
      return getTime(value, type, separation)
    }
  }
}
</script>

<style lang="less" scoped>
.announcement-ul {
  background: #fff;
  text-align: left;
  padding: 20px;

  .announcement-li:hover {
    border-bottom: 2px solid #9C1D22;

    .announcement-time {
      .month {
        color: #9C1D22;
      }

      .day {
        color: #9C1D22;
      }
    }
  }

  .announcement-li:last-child {
    margin-bottom: 0;
  }

  .announcement-li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin-bottom: 24px;
    border-bottom: 2px solid #fff;

    .announcement-text {
      width: calc(100% - 92px);

      .announcement-h {
        color: #222222;
        font-size: 18px;
        line-height: 18px;
        font-weight: bold;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        margin-bottom: 10px;
      }

      .announcement-p {
        color: #626365;
        font-size: 16px;
        line-height: 26px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
    }

    .announcement-time {
      width: 74px;
      height: 74px;
      background: #F5F5F7;
      padding-top: 11px;
      box-sizing: border-box;
      text-align: center;

      .month {
        color: #999999;
        font-size: 14px;
        line-height: 14px;
        margin-top: 4px;
      }

      .day {
        color: #333333;
        font-size: 34px;
        font-weight: bold;
        line-height: 34px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/announcement.vue